import { createSlice } from '@reduxjs/toolkit';

import { fetchRotations } from '../actions/geofence-rotations';

const rotation = createSlice({
  name: 'rotation',
  initialState: {
    error: null,
    loading: true,
    data: [],
    rotationDetail: null,
  },
  reducers: {
    setRotationDetail: (state, action) => {
      state.rotationDetail = action.payload;
    },
    clearRotationDetail: (state) => {
      state.rotationDetail = null;
    },
  },
  extraReducers: builder => {
    builder
      // Fetch All Rotations
      .addCase(fetchRotations.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchRotations.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchRotations.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { setRotationDetail, clearRotationDetail } = rotation.actions;


export default rotation.reducer;
